<template>
  <translations-tabs>
    <template #default="{language}">
      <VWidget
        :title="$t('Extras')"
      >
        <div slot="widget-header-action">
          <v-btn
            :disabled="hasParent"
            flat
            class="text--secondary text-capitalize"
            @click="addOption"
          >
            {{ $t('Add option') }}
          </v-btn>
        </div>
        <div
          slot="widget-content"
        >
          <template v-if="hasParent">
            <div v-if="getParentExtras.length">
              <template v-for="extra in getParentExtras(language)">
                <product-extra
                  :key="`${extra.key}_${language.code}`"
                  :value="extra"
                  :disabled="true"
                />
              </template>
            </div>
            <div v-else>
              <span>{{ $t('No extras') }}</span>
            </div>
          </template>
          <template v-else>
            <translatable-collection
              v-model="product"
              :language="language"
              :item-component="ExtraComponent"
              :creating="creating"
              field-name="extras"
              subfield-name="options"
              no-items-text="No Extras"
              @created="creating = false"
            />
          </template>
        </div>
      </VWidget>
    </template>
  </translations-tabs>
</template>

<script>
import ProductExtra from '@/modules/Products/components/ProductExtra'
import TranslatableCollection from '@/components/widgets/TranslatableCollection'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'

export default {
  name: 'ProductSingleExtras',
  components: { TranslationsTabs, TranslatableCollection, ProductExtra },
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      ExtraComponent: ProductExtra,
      creating: false
    }
  },

  computed: {
    hasParent () {
      return !!(this.product.parent_id && this.product.parent)
    }
  },

  methods: {
    getParentExtras (lang) {
      if (!this.hasParent) {
        return []
      }

      if (lang.default) {
        return this.product.parent.extras || []
      }

      return this.product.translations[lang.code].extras || []
    },

    addOption () {
      if (!this.product.extras) {
        this.product.extras = []
      }

      this.creating = true
    }
  }
}
</script>
